import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import VideoHero from '@/components/promo/VideoHero';
import SepLine from '@/components/promo/SepLine';
import LetsTalk from '@/components/promo/LetsTalk';
import { promoApi, type BlogPost } from '@/lib/api/promoApi';

export default function Blog() {
  const [posts, setPosts] = useState<BlogPost[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    promoApi.getBlogPosts()
      .then(setPosts)
      .catch((err) => console.error('[Blog]', err))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div id="blog">
      <VideoHero videoSrc="/assets/videos/blog.mp4" imageSrc="/assets/images/blog.png">
        <h1>Blog</h1>
        <h2>Check out our news</h2>
      </VideoHero>

      <div className="page-content" style={{ paddingBottom: 0 }}>
        <div style={{ padding: '50px 20px 0' }}>
          <h3 style={{ textAlign: 'center', fontSize: 22, letterSpacing: 4, color: '#333' }}>Blog</h3>
        </div>

        <SepLine />

        {loading ? (
          <p style={{ textAlign: 'center', padding: 60, color: '#999' }}>Loading...</p>
        ) : posts.length === 0 ? (
          <div className="nothing-found">No blog posts found</div>
        ) : (
          <div className="blog-news-grid">
            {posts.map((post) => (
              <div key={post.slug} className="blog-post-outer-wrapper">
                <div className="blog-post-wrapper">
                  <Link className="link-wrap" to={`/blog/${post.slug}`}>
                    <div className="blog-post-image-wrapper">
                      <div className="blog-post-date">{post.publicationDateAt}</div>
                      <img
                        className="blog-post-image"
                        src={post.mainPicture?.[0]?.url}
                        alt={post.title}
                        loading="lazy"
                      />
                      <div className="blog-post-title">{post.title}</div>
                    </div>
                    {post.introduction && (
                      <div className="blog-post-content">
                        <div
                          className="blog-post-preview"
                          dangerouslySetInnerHTML={{ __html: post.introduction }}
                        />
                        <div className="blog-post-details">
                          <span style={{ color: 'var(--vivid-green)', fontSize: 14 }}>Continue reading</span>
                        </div>
                      </div>
                    )}
                  </Link>
                </div>
              </div>
            ))}
          </div>
        )}

        <SepLine invisible />
        <LetsTalk />
      </div>
    </div>
  );
}
